import { MonitorIcon, MoonIcon, SunIcon } from "lucide-react";
import { isThemePreference, useTheme } from "./ThemeProvider";
import { DropdownMenuRadioGroup, DropdownMenuRadioItem } from "./ui";

/**
 * Light / Dark / System selector for dropdown menus (sidebar footer and the
 * top-nav user menu). The preference is stored per device — see ThemeProvider.
 */
export const ThemeMenuRadioItems = () => {
  const { theme, setTheme } = useTheme();

  return (
    <DropdownMenuRadioGroup
      value={theme}
      onValueChange={(value) => {
        if (isThemePreference(value)) {
          setTheme(value);
        }
      }}
    >
      <DropdownMenuRadioItem value="light" data-testid="theme-option-light">
        <SunIcon className="mr-2 h-4 w-4" />
        Light
      </DropdownMenuRadioItem>
      <DropdownMenuRadioItem value="dark" data-testid="theme-option-dark">
        <MoonIcon className="mr-2 h-4 w-4" />
        Dark
      </DropdownMenuRadioItem>
      <DropdownMenuRadioItem value="system" data-testid="theme-option-system">
        <MonitorIcon className="mr-2 h-4 w-4" />
        System
      </DropdownMenuRadioItem>
    </DropdownMenuRadioGroup>
  );
};
